import { Reveal } from "@/components/Reveal";
import { SplitText } from "@/components/liquid/SplitText";

// Resolve the immersive theme ("dark" Midnight Silk / "light" Pearl Ivory).
// When the backoffice auto scheduler is on, follow the visitor's local time:
// Pearl Ivory 07:00–19:00, Midnight Silk at night.
export const isLightImm = (settings) => {
  if (settings?.imm_theme_auto === "on") {
    const h = new Date().getHours();
    return h >= 7 && h < 19;
  }
  return settings?.imm_theme === "light";
};
export const immTheme = (settings) => (isLightImm(settings) ? "imm-light" : "imm-dark");

// Editorial page header for the Immersive 3D design (theme-token driven).
export const ImmHeader = ({ index, eyebrow, title, subtitle, testid }) => (
  <div className="relative">
    <div className="flex items-start justify-between gap-6">
      <div className="max-w-3xl">
        <Reveal>
          <p className="text-[11px] font-medium uppercase tracking-[0.4em] text-[#D4AF37]/80">{eyebrow}</p>
        </Reveal>
        <h1 className="t-imm mt-6 font-display text-[clamp(3rem,8vw,7rem)] font-normal leading-[0.95] tracking-tight">
          <SplitText text={title} delay={0.2} testid={testid} />
        </h1>
        {subtitle && (
          <Reveal delay={0.5}>
            <p className="t-imm-muted mt-6 max-w-xl text-sm font-light leading-relaxed sm:text-base">{subtitle}</p>
          </Reveal>
        )}
      </div>
      <Reveal delay={0.3} className="hidden shrink-0 lg:block">
        <span className="font-display text-7xl italic text-[#D4AF37]/50" aria-hidden="true">{index}</span>
      </Reveal>
    </div>
    <Reveal delay={0.4}>
      <div className="bg-imm-line mt-10 h-px w-full" aria-hidden="true" />
    </Reveal>
  </div>
);

// Shared glass card style for immersive pages (theme-aware)
export const immCard = "rounded-[4px] imm-glass";
